import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { convertObjectKeysToSnakeCase } from "../../Shared/ConvertObjectKeysToSnakeCase";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const enrollInFreeTier = ({ onResponse, onError, body }) => {
  fetch(
    "/api/job_prospects/enroll",
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const subscribeToPremium = ({ onResponse, onError, body }) => {
  fetch(
    "/api/stripe/subscription",
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const getJobProspects = ({ onResponse, onError }) => {
  fetch(
    "/api/job_prospects",
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const updateCandidateInterestLevelInJobProspect = ({ body, onResponse, onError }) => {
  fetch(
    "/api/job_prospects/update_candidate_interest_level_in_job_prospect",
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const updateJobProspectStatus = ({ body, onResponse, onError }) => {
  fetch(
    "/api/job_prospects/update_job_prospect_status",
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const getPreferredJobLocations = ({ onResponse, onError }) => {
  fetch(
    "/api/job_prospects/preferred_job_locations",
    {
      method: HTTPRequestMethods.GET,
      headers: { 'Content-Type': 'application/json' },
    }
  )
  .then(response => parseJsonResponse({ response, onResponse, onError }))
  .catch((error) => onError({ feedbackMessage: error.message, feedbackVariant: "error" }));
};

export const addPreferredJobLocation = ({ body, onResponse, onError }) => {
  fetch(
    "/api/job_prospects/preferred_job_locations",
    {
      method: HTTPRequestMethods.POST,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => parseJsonResponse({ response, onResponse, onError }))
  .catch((error) => onError({ feedbackMessage: error.message, feedbackVariant: "error" }));
};

export const removePreferredJobLocation = ({ id, body, onResponse, onError }) => {
  fetch(
    `/api/job_prospects/preferred_job_locations/${id}`,
    {
      method: HTTPRequestMethods.DELETE,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => parseJsonResponse({ response, onResponse, onError }))
  .catch((error) => onError({ feedbackMessage: error.message, feedbackVariant: "error" }));
};

export const getJobTitlePreferences = ({ onResponse, onError }) => {
  fetch(
    "/api/job_prospects/job_title_preferences",
    {
      method: HTTPRequestMethods.GET,
      headers: { 'Content-Type': 'application/json' },
    }
  )
  .then(response => parseJsonResponse({ response, onResponse, onError }))
  .catch((error) => onError({ feedbackMessage: error.message, feedbackVariant: "error" }));
};

export const addJobTitlePreference = ({ body, onResponse, onError }) => {
  fetch(
    "/api/job_prospects/job_title_preferences",
    {
      method: HTTPRequestMethods.POST,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => parseJsonResponse({ response, onResponse, onError }))
  .catch((error) => onError({ feedbackMessage: error.message, feedbackVariant: "error" }));
};

export const removeJobTitlePreference = ({ id, body, onResponse, onError }) => {
  fetch(
    `/api/job_prospects/job_title_preferences/${id}`,
    {
      method: HTTPRequestMethods.DELETE,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => parseJsonResponse({ response, onResponse, onError }))
  .catch((error) => onError({ feedbackMessage: error.message, feedbackVariant: "error" }));
};

export const generateResume = ({ jobProspectId, body, onResponse, onError }) => {
  fetch(
    `/api/job_prospects/${jobProspectId}/generate_resume`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
